angular.module('leanlaw').controller('ClientsExportCtrl', ['$scope', '$q', '$window', '$location', '$stateParams', 'clientsservice', '$state', '$timeout', function ($scope, $q, $window, $location, $stateParams, clientsservice, $state, $timeout) {
  $scope.selectedFilter = 'Active';
  $scope.query = {
    name: ""
  };
  /* Alerts */
  $scope.alerts = [];
  $scope.addAlert = function (type, message) {
    $scope.alerts = [];
    var alert = {
      type: type,
      msg: message
    };
    console.log('Adding alert: ' + alert);
    $scope.alerts.push(alert);
    $timeout(function () {
      console.log('Removing alert: ' + alert);
      $scope.alerts.splice($scope.alerts.indexOf(alert), 1);
    }, 20000);
  };

  /* End Alerts */

  $scope.clientFilter = function (item) {
    $scope.selectedFilter = item;
    $scope.getClients(item);
  };
  $scope.pagination = {
    current: 1
  };
  $scope.data = clientsservice.getDataModel();
  $scope.isLoading = true;
  clientsservice.getnonQbClients($scope.data).then(function (d) {
    $scope.isLoading = false;
    $scope.data.clients = d.clients;
  });
  $scope.pageChanged = function (newPage) {
    getResultsPage(newPage);
  };
  function getResultsPage(pageNumber) {
    if ($scope.query.name.length < 3) {
      $scope.isLoading = true;
      clientsservice.getnonQbClients($scope.data).then(function (d) {
        $scope.isLoading = false;
        $scope.data.clients = d.clients;
      });
    } else {
      $scope.isLoading = true;
      clientsservice.getnonQbClients($scope.data).then(function (d) {
        $scope.isLoading = false;
        $scope.data.clients = d.clients;
      });
    }
  }
  $scope.filterList = function (e) {
    if ($scope.query.name.length >= 3) {
      $scope.isLoading = true;
      clientsservice.getnonQbClients($scope.data).then(function (d) {
        $scope.isLoading = false;
        $scope.data.clients = d.clients;
      });
    } else if ($scope.query.name.length == 0) {
      $scope.isLoading = true;
      clientsservice.getnonQbClients($scope.data).then(function (d) {
        $scope.isLoading = false;
        $scope.data.clients = d.clients;
      });
    }
  };
  $scope.filterOptions = ['Active', 'Archived'];
  $scope.createCustomerFromClient = function (client) {
    $scope.selectedClient = client.clientId;
    $scope.isLoading = true;
    clientsservice.saveClientToQb($scope.data, $scope.selectedClient).then(function (e) {
      clientsservice.getnonQbClients($scope.data).then(function (d) {
        $scope.isLoading = false;
        $scope.data.clients = d.clients;
        $scope.data.messages = d.messages;
        if ($scope.data.messages.length > 0) {
          for (var i = 0; i < $scope.data.messages.length; i++) {
            $scope.addAlert('error', $scope.data.messages[i]);
          }
        }
      });
    });
  };
  $scope.goBack = function () {
    var url = "/import";
    $scope.qbName = '';
    $scope.qbEmail = '';
    $scope.qbId = '';
    $location.url(url);
  };
  $scope.bulkExport = function () {
    bootbox.confirm("This will export all current clients and " + $scope.me.terms.matter + "s from UserFirst to QuickBooks.  A new customer record will be created for each export that is not already tied to an existing client or " + $scope.me.terms.matter + ".  Do you wish to proceed?", function (result) {
      if (result) {
        $scope.isLoading = true;
        clientsservice.bulkExportClients($scope.data).then(function (e) {
          if (e.messages.messages.length > 0) {
            //for (var i = 0; i < e.messages.messages.length; i++) {
            //    $scope.addAlert('error', e.messages.messages[i]);
            //}
            $scope.addAlert('error', "The remaining clients did not export.  This is most likely because QuickBooks already has customer records with the same name");
          } else {
            $scope.addAlert('success', "Clients exported");
          }
          clientsservice.getnonQbClients($scope.data).then(function (d) {
            $scope.data.clients = d.clients;
            $scope.data.messages = d.messages;
            $scope.isLoading = false;
          });
        });
      }
    });
  };
  $scope.saveQbToClient = function (id) {
    bootbox.confirm("A new client record will be created for the selected QuickBooks customer if it is not already tied to an existing client.  Do you wish to proceed?", function (result) {
      if (result) {
        $scope.isLoading = true;
        clientsservice.saveQbToClientData(id).then(function (d) {
          $scope.addAlert('success', "Customer Imported");
          getResultsPage(1);
        });
      }
    });
  };
  $scope.$on('refreshTable', function (event, args) {
    $scope.selectedFilter = 'Active';
    $scope.getClients($scope.selectedFilter);
    $scope.addAlert('success', "Client saved");
  });
  $scope.archiveClient = function (client) {
    bootbox.confirm("Are you sure you wish to archive this client?", function (result) {
      if (result) {
        clientsservice.archiveClient($scope.data, client.clientId, true).then(function (d) {
          $scope.data.clients.splice($scope.data.clients.indexOf(client), 1);
          $scope.addAlert('success', "Client archived");
        });
      }
    });
  };
  $scope.activateClient = function (client) {
    bootbox.confirm("Are you sure you wish to re-activate this client?", function (result) {
      if (result) {
        clientsservice.archiveClient($scope.data, client.clientId, false).then(function (d) {
          $scope.data.clients.splice($scope.data.clients.indexOf(client), 1);
          $scope.addAlert('success', "Client re-activated");
        });
      }
    });
  };
}]);